import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { onBeforeUnmount, onMounted, ref } from 'vue';
import AppButton from '@/core/components/form/AppButton.vue';
import appModalControl from '@/core/components/appModalControl';

interface BaseModalProps {
	header?: boolean,
	footer?: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppModal',
  props: {
    header: { type: Boolean, default: true },
    footer: { type: Boolean, default: true }
  },
  emits: [
	'close',
],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const modal = ref<HTMLDivElement>();
const lastFocus: HTMLElement | null = document.activeElement as HTMLElement | null;

const close = () => {
	emit('close');
};

const keyup = (e) => {
	if ((e.code && e.code === 'Escape') || e.keyCode === 27) {
		close();
	}
};

onMounted(() => {
	addEventListener('keyup', keyup);
	appModalControl.addToStack(modal.value as HTMLDivElement);
});

onBeforeUnmount(() => {
	removeEventListener('keyup', keyup);
	appModalControl.popStack();

	if (lastFocus) {
		lastFocus.focus();
	}
});

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
    _createElementVNode("div", {
      class: "modal-mask",
      ref_key: "modal",
      ref: modal
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { tabindex: "0" }, null, -1)),
      _createVNode(AppButton, {
        class: "modal-close-button",
        icon: "times",
        onClick: _withModifiers(close, ["prevent"])
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.header)
            ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
                _renderSlot(_ctx.$slots, "header")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", null, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          (__props.footer)
            ? (_openBlock(), _createElementBlock("footer", _hoisted_4, [
                _renderSlot(_ctx.$slots, "footer", {}, () => [
                  _createVNode(AppButton, {
                    onClick: _withModifiers(close, ["prevent"]),
                    class: "t-success",
                    icon: "check-circle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("OK", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { tabindex: "0" }, null, -1))
    ], 512)
  ]))
}
}

})